import { Chip, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TrustedIcon from '../../assets/icons/trusted_icon.svg?react';

interface OrderByTrustedSupplierChipProps {
  sx?: SxProps
}

export default function OrderByTrustedSupplierChip({ sx }: OrderByTrustedSupplierChipProps): React.JSX.Element {
  const { t } = useTranslation(['order']);

  return (
    <Chip
      label={t('order:suggestion_auto_validated')}
      variant="tag"
      icon={<TrustedIcon />}
      sx={sx}
    />
  );
}
